import React from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";


export default function VendorJoin() {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className="start-earning-section">
        <Container>
          <Row>
            <Col lg={6}>
              <div className="pre-registration join-our-net">
                <div className="pre-registration-box">
                  <h2>
                    Join our network of Trusted Electricians and start earning
                    Today
                  </h2>
                  <div className="registraton-section-sec d-flex align-items-center gap-2">


                  <div className="pre-registration-form d-flex">

                    <button type="button" onClick={() => navigate("/pre-registration")}>
                      Get Started
                    </button>
                 
                  </div>

                  <div className="trial-desc">
                      <p>Free 3-month trial!</p>
                      <span>(limited time only)</span>

                    </div>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={6}>
              <div className="join-our-network">
                <div className="right-side-net-image">
                  <img
                    src={require("../assets/images/registration-mobile-img.png")}
                    alt="join image"
                  />
                </div>
              </div>
            </Col>
          </Row>

          <div className="why-join-spark-sec">
            <div className="heading-text-pro">
              <h2>Why Join SparkPro? </h2>
            </div>

            <div className="get-high-quality-grid">
              <div className="grow-your-business">
                <div className="quality-leads-icon">
                  <div className="pro-icon">
                    <img
                      src={require("../assets/images/stepone.png")}
                      alt="join image"
                    />
                  </div>
                  <h3>Get High-Quality Leads</h3>
                </div>
                <div className="leads-cont">
                  <p>
                    ✔ Access Local Job Requests – We connect you with customers
                    actively looking for electricians in your area.
                  </p>
                  <p>
                    ✔ Only Pay for the Leads You Want – Browse available jobs
                    and purchase leads that match your expertise.
                  </p>
                </div>
              </div>

              <div className="grow-your-business">
                <div className="quality-leads-icon">
                  <div className="pro-icon">
                    <img
                      src={require("../assets/images/stepthree.png")}
                      alt="join image"
                    />
                  </div>
                  <h3>Grow Your Business Effortlessly</h3>
                </div>
                <div className="leads-cont">
                  <p>
                    ✔ Attract More Customers - Showcase your skills, experience,
                    and customer reviews to win more work.
                  </p>
                  {/* <p>
                    ✔ Subscription Options - Choose between Standard (£80/mo) or
                    Premium (£120/mo) for added benefits like included quotes,
                    premium placement, and direct customer contact.
                  </p> */}
                  <p>
                    ✔ Go Premium for more visibility - Get priority placement in search results.
                  </p>
                </div>
              </div>

              <div className="grow-your-business">
                <div className="quality-leads-icon">
                  <div className="pro-icon">
                    <img
                      src={require("../assets/images/steptwo.png")}
                      alt="join image"
                    />
                  </div>
                  <h3>Flexible & Affordable</h3>
                </div>
                <div className="leads-cont">
                  <p>
                    ✔ No Upfront Costs - Sign up for free and only pay when you're ready to secure leads.
                  </p>
                  <p>
                    ✔ Simple Subscription Options - Choose Standard (£80/mo) or Premium (£120/mo). Premium includes extra quote credits and enhanced profile visibility.
                  </p>
                  <p>
                    ✔ Need More Quotes? - Easily top up your quote credits anytime with flexible add-on packages.
                  </p>
                </div>
              </div>
            </div>

            <div className="leads-for-less">
              <div className="qualified-heding-side">
                <h2>Qualified Leads for Less</h2>
                <p>
                  No high commissions. No bidding wars. Just direct, affordable connections to real customers. SparkPro helps you get more jobs for less—simple, cost-effective, and hassle-free.
                </p>
                {/* <p>Get more jobs for less!</p> */}
              </div>
              <div className="qualified-right-image">
                <img
                  src={require("../assets/images/qualified-less-right.png")}
                  alt="join image"
                />
              </div>
            </div>

            <div className="how-it-works">
              <div className="wrok-title">
                <h2>How It Works</h2>
              </div>

              <div className="sign-up-count mt-sm-5 ">
                <div>
                  <img
                    src={require("../assets/images/one.svg").default}
                    alt="join image"
                  />
                </div>
                <div className="complete-step">
                  <h3>Sign up & Complete Your Profile</h3>
                  <p>
                    Tell us about your business, qualifications, and the
                    services you offer.
                  </p>
                </div>
              </div>

              <div className="sign-up-count">
                <div>
                  <img
                    src={require("../assets/images/two.svg").default}
                    alt="join image"
                  />
                </div>
                <div className="complete-step">
                  <h3>Browse & Claim Leads</h3>
                  <p>
                    View job requests in your area and use credits to respond to
                    the ones that match your expertise
                  </p>
                </div>
              </div>

              <div className="sign-up-count">
                <div>
                  <img
                    src={require("../assets/images/three.svg").default}
                    alt="join image"
                  />
                </div>
                <div className="complete-step">
                  <h3>Win More Jobs & Get Paid</h3>
                  <p>
                    Contact customers, provide quotes and secure more work with
                    ease!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </Layout>
  );
}

